import { z } from "zod";

//QualidadeProcessosRiscosCopiaSchema

const optionalString = z.coerce.number();

export const QualidadeProcessoRiscosCopiaSchema = z.object({
  IdProcessos: z.number().optional(),
  ano: optionalString,
});

// QualidadeProcessosRiscosCopiaForm


export type QualidadeProcessoRiscosCopiaForm = z.infer<typeof QualidadeProcessoRiscosCopiaSchema>;

export const defaultProcessoRiscosCopiaForm: Partial<QualidadeProcessoRiscosCopiaForm> = {
  ano: 0,
}